import { FT_SEMANTIC_TYPOGRAPHY_TOKENIZATION } from '@whitbread-eos/api';
import useFeatureToggle from './use-feature-toggle';
export default function useSemanticTypography() {
  var _useFeatureToggle = useFeatureToggle(),
    isSemanticTypographyEnabled = _useFeatureToggle[FT_SEMANTIC_TYPOGRAPHY_TOKENIZATION];
  return (legacyTypography, semanticTypography) => {
    return isSemanticTypographyEnabled && semanticTypography.textStyle ? semanticTypography : legacyTypography;
  };
}